export function replaceAll(str: string, search: string, replacement: string): string {
  const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return str.replace(new RegExp(escaped, "g"), replacement);
}

export function isNotNullOrUndefined(value: unknown): boolean {
  return value !== null && value !== undefined && 
  value !== 'null' && value !== 'undefined';
}

export function checkIfCandidateCanApply(
  authorizedEmails: string[],
  authenticatedUserEmail: string,
  isOfferPrivate: boolean
): boolean {
  if (!authenticatedUserEmail) {
    return !isOfferPrivate;
  }
  if (!isOfferPrivate) {
    return true;
  }
  if (!authorizedEmails || authorizedEmails.length === 0) {
    return false;
  }
  for (const item of authorizedEmails) {
    const escaped = item.replace(/[.+?^${}()|[\]\\]/g, '\\$&');

    if (item.includes('*')) {
      const pattern = new RegExp('^' + escaped.replace(/\*/g, '.*') + '$', 'i');
      if (pattern.test(authenticatedUserEmail)) {
        return true;
      }
    } else if (item.includes('all')) {
      const pattern = new RegExp('^' + escaped.replace(/all/g, '.*') + '$', 'i');
      if (pattern.test(authenticatedUserEmail)) {
        return true;
      }
    } else if (item.toLowerCase() === authenticatedUserEmail.toLowerCase()) {
      return true;
    }
  }

  return false;
}

export function isEnumValue<T extends Record<string, string | number>>(
    enumType: T,
    value: string | number
): boolean {
    return Object.values(enumType).includes(value as T[keyof T])
}

export function getMatch (str: string, mailAssociatedVariables: any) {
    return str.replace(/\${\w+}/g, (match) => {
        const cleanVariable = match.slice(2, -1);
        return mailAssociatedVariables[cleanVariable] || match;
    })
}

export function escapeRegex (str: string) { 
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
};

export function youtube_parser(url: string) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    const match = url.match(regExp)
    // eslint-disable-next-line eqeqeq
    return (match && match[7].length == 11) ? match[7] : false
}


export function parseStringToArrayOfString(
    value: string,
    separator: string
  ): string[] {
    return value ? value.split(separator).map((item) => item.trim()) : [];
}

export function waitFor(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
}
function extractContent(s: string) {
  var span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
};

export const toListItems = (items: string[]): string => {
    const formattedItems = items.map((i) => extractContent(i))
    return `<ul style="padding: 18px;list-style-type: square;">${formattedItems.map(item => item.length > 0 ? `<li>${item}</li>` : null).filter(Boolean).join('')}</ul>`;
}

export function getUniqueListBy(array: any[], key: string) {
    return [...new Map(array.map(item => [item[key], item])).values()]
}


export function weightedAverage(criteria: { [key: string]: any, details: { ratingValue: number, value: number }[] }): number {
  let weightedSum = 0
  let totalWeight = 0

  for (let i = 0; i < criteria.details.length; i++) {
    const rating = criteria.details[i]
    weightedSum += rating.ratingValue * rating.value
    totalWeight += rating.ratingValue
  }

  if (totalWeight === 0) return 0
  return Number((weightedSum / totalWeight).toPrecision(2))
}

export function weightedAverageWithSections(
  sections: {
    weight: number;
    criteria: { ratingValue: number; value: number }[];
  }[]
): number {
  let totalSectionWeight = 0;
  let weightedSum = 0;

  for (const section of sections) {
    let sectionWeightedSum = 0;
    let sectionTotalWeight = 0;

    for (const criterion of section.criteria) {
      sectionWeightedSum += criterion.ratingValue * criterion.value;
      sectionTotalWeight += criterion.ratingValue;
    }

    const sectionScore = sectionTotalWeight === 0
      ? 0
      : sectionWeightedSum / sectionTotalWeight;

    weightedSum += section.weight * sectionScore;
    totalSectionWeight += section.weight;
  }

  if (totalSectionWeight === 0) return 0;
  return Number((weightedSum / totalSectionWeight).toPrecision(2));
}

export function formatDateForReport(language: string, dateString: string) {
    const date = new Date(dateString);
    const formatted = date.toLocaleDateString(language, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });
    return formatted
}

export function escapeHtml(str: string) {
    if (!str) return '';
    return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function hasAllScopes(scopes: string[], permissions: {
    action: string | string[];
    scope: string | string[];
}[]): boolean {
    const permissionScopes = permissions.flatMap(p =>
      Array.isArray(p.scope) ? p.scope : [p.scope],
    );
    return scopes.every(scope => permissionScopes.includes(scope));
}

export function hasOnlyScope(
  scopes: string[],
  permissions: {
    action: string | string[];
    scope: string | string[];
  }[],
): boolean {
  const permissionScopes = [...new Set(permissions.flatMap(p =>
    Array.isArray(p.scope) ? p.scope : [p.scope],
  ))]
  if (permissionScopes.some(scope => !scopes.includes(scope)))
    return false;
  if (scopes.some(scope => !permissionScopes.includes(scope)))
    return false
  return true
}

export function sanitizeSheetName(title: string | undefined, suffix = "_informations"): string {
  if (!title) return `Sheet${suffix}`;
  let sanitized = title.replace(/\s+/g, "_");
  sanitized = sanitized.replace(/[*?:\\/\[\]]/g, "");
  sanitized = sanitized.replace(/[^\x00-\x7F]/g, "");
  sanitized = sanitized.slice(0, 31);

  return `${sanitized}${suffix}`.slice(0, 31);
}

export function extractPathFromUrl(url: string): string | null {
  if (!url) return null;
  if (url.startsWith('@')) return url
  try {
    const decodedUrl = decodeURIComponent(url);
    const atIndex = decodedUrl.indexOf('@');
    if (atIndex !== -1) {
      return decodedUrl.substring(atIndex);
    }
    return null;
  } catch (error) {
    const atIndex = url.indexOf('@');
    if (atIndex !== -1) {
      return url.substring(atIndex);
    }
    const percent40Index = url.indexOf('%40');
    if (percent40Index !== -1) {
      return decodeURIComponent(url.substring(percent40Index));
    }
    return null;
  }
}